import notify from "devextreme/ui/notify";
import React, { useRef, useState } from "react"
import { useSelector } from "react-redux";
import { DataGrid, Modal } from "../../components"
import { GridButtonType } from "../../components/data-grid/types";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { adminCategories } from "../../services/urls";
import { CreateCategoryForm } from "./create";
import CategoryDetail from "./detail";
import { RealAdminCategories, RequestAdminCategories } from "./type";

const CategoryPage = () => {
    const [show, setShow] = useState(false)
    const localize = useSelector(getLocalized);
    const { token, lang } = useSelector(getApiParams);
    const [clearComponent, setClearComponent] = useState<boolean>(false)
    const [clearForm, setClearForm] = useState<boolean>(false)
    const formRef = useRef<any>();
    const realData = useRef<RealAdminCategories>({
        Color: "",
        Description: "",
        Icon: "",
        Name: "",
        Order: 0,
        ParentCategoryId: "",
        Seo: ""
    })
    const columns = [
        {
            dataField: "ParentCategoryName",
            caption: localize.getString("parentCategory")
        },
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "Description",
            caption: localize.getString("description")
        },
        {
            dataField: "Order",
            caption: localize.getString("order")
        }
    ]
    const data = useRef<RequestAdminCategories>({
        Categories: [],
        Color: "",
        Description: "",
        Icon: "",
        Name: "",
        Order: 0,
        ParentCategoryId: "",
        Seo: ""
    })
    const buttons: GridButtonType[] = [
        {
            buttonText: "Yeni",
            icon: "add",
            type: "success",
            onclick: () => {
                setShow(true)
            }
        }
    ]
    return <>
        <Modal
            coverModal={false}
            width={"70%"}
            visible={show}
            onHiding={() => {
                setClearForm(!clearForm)
                setShow(false)
            }}
            title={localize.getString("categoryCreateForm")}
            height={"60%"}
            onSubmitClick={async () => {

                realData.current.Color = data.current.Color
                realData.current.Description = data.current.Description
                realData.current.Icon = data.current.Icon
                realData.current.Name = data.current.Name
                realData.current.Order = data.current.Order
                realData.current.ParentCategoryId = data.current.Categories[data.current.Categories.length - 1]
                realData.current.Seo = data.current.Seo
           
                const response: ApiResponse<RealAdminCategories> = await createRequest({
                    method: "POST",
                    url: "/api/admin/categories",
                    bodyType: BodyType.formdata,
                    token,
                    body: realData.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")
                    setShow(false)
                    setClearComponent(true)
                    setClearForm(!clearForm)
                } else {
                    notify(response.Message, "warning")
                }
            }}
        >
            <CreateCategoryForm data={data.current} ref={formRef} clearcomponent={clearComponent} clearForm={clearForm}/>
        </Modal>
        <DataGrid
            url={adminCategories}
            getByIdUrl={adminCategories}
            columns={columns || []}
            refObject={{}}
            gridButtons={buttons}
            title={localize.getString("categories")}
            details={{
                width: "70%",
                height: "70%",
                getByIdUrl: adminCategories,
                title: localize.getString("categoryDetail"),
                component: CategoryDetail,
            }}
            remove={{
                url: "api/admin/categories"
            }}
        />
    </>
}

export default CategoryPage